export const resetPasswordConstants = {
  RESET_PASSWORD: 'RESET_PASSWORD',
};
